import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {counties} from "../../../constants/constants";

const DistrictFilter = ({
    city,
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    selectMarginBottom = "20px",
    allowClear = false,
    disabled = false
}) => {
    const {t} = useTranslation();

    const districts = city && counties[city.toLowerCase()] ? counties[city.toLowerCase()] : [];

    return (
        <React.Fragment>
            {showLabel && <h5>İlçe</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="district"
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                disabled={disabled}
            >
                {showAllOption && (
                    <SelectField.Option value="all">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {arrayAlphabeticalSort(districts).map((district, i) => (
                    <SelectField.Option
                        data-testid="district_option"
                        key={i}
                        value={district.value}
                    >
                        {district.name}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default DistrictFilter;
